import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { useQuoteContext } from 'modules/public/quote/QuoteScreen';
import { useUser } from 'components/user/UserProvider';
import i18n from 'components/translation/i18n';
import { useDealDetailContext } from 'modules/deal/DealDetails';
import { useBreakpoint } from 'components/util/BreakpointProvider';
import '../DealItemPanelGroupContent.scss';
import { useAccount } from 'components/account/AccountProvider';
export function DealItemPricingTableHeader(props) {
    const { pricingParametersDisplay, className, editable, hideSKU, isItem, isOption, isPackage, itemsGrouped, quantityType, pricingDisplay, showDateColumn } = props;
    const user = useUser();
    const breakPoint = useBreakpoint();
    const dealConfiguratorContext = useDealConfiguratorContext();
    const quoteContext = useQuoteContext();
    const dealDetailContext = useDealDetailContext();
    const account = useAccount();
    let dealerColumn = true;
    if (account.tag === 'clubpiscine' || account.tag === 'groupenadeau') {
        dealerColumn = false;
    }
    const quantityTypeValue = quantityType && quantityType != ''
        ? quantityType
        : dealConfiguratorContext.quantityType != ''
            ? dealConfiguratorContext.quantityType
            : quoteContext.quantityType;
    const quoteDealItemFields = quoteContext.dealItemFields.length > 0
        ? quoteContext.dealItemFields
        : dealDetailContext.dealItemFields.length > 0
            ? dealDetailContext.dealItemFields
            : dealConfiguratorContext.dealItemFields;
    const quoteDealItemConfigurationFields = quoteContext.dealItemConfigurationFields.length > 0
        ? quoteContext.dealItemConfigurationFields
        : dealDetailContext.dealItemConfigurationFields.length > 0
            ? dealDetailContext.dealItemConfigurationFields
            : dealConfiguratorContext.dealItemConfigurationFields;
    const dealerDiscount = dealConfiguratorContext.discountRep;
    const pricingParameters = dealConfiguratorContext
        ? dealConfiguratorContext.pricingParameters
        : quoteContext.pricingParameters;
    const hasDealItemConfigurationTime = dealConfiguratorContext.hasDealItemConfigurationTime ||
        quoteContext.hasDealItemConfigurationTime;
    const cellHeader = isItem
        ? t('Product')
        : isOption
            ? t('Option')
            : t('Package');
    if (!editable && breakPoint.isBelow('md')) {
        return null;
    }
    return (React.createElement("tr", { className: className + ' deal-item-pricing-table-header' },
        React.createElement("th", null, cellHeader),
        hideSKU === 'FALSE' && React.createElement("th", null, t('SKU')),
        ((isOption && !itemsGrouped) || isPackage) && (React.createElement(React.Fragment, null,
            React.createElement("th", null, t('Category')))),
        (isOption || isPackage) && hasDealItemConfigurationTime && (React.createElement("th", null, t('Time'))),
        !isOption && !isPackage && (React.createElement(React.Fragment, null,
            React.createElement("th", null))),
        isItem && showDateColumn && React.createElement("th", { className: "column-date" }, t('Date')),
        !isOption && !isPackage && quoteDealItemFields.length > 0
            ? quoteDealItemFields.map((field) => {
                var _a;
                return (React.createElement("th", { key: field.id },
                    React.createElement(Text, { className: "deal-item-panel-title field", value: (_a = field.translations.find((translation) => translation.language.code === i18n.language)) === null || _a === void 0 ? void 0 : _a.title })));
            })
            : null,
        (isOption || isPackage) && quoteDealItemConfigurationFields.length > 0
            ? quoteDealItemConfigurationFields.map((field) => {
                var _a;
                return (React.createElement("th", { key: field.id },
                    React.createElement(Text, { className: "deal-item-panel-title field", value: (_a = field.translations.find((translation) => translation.language.code === i18n.language)) === null || _a === void 0 ? void 0 : _a.title })));
            })
            : null,
        isItem && React.createElement("th", { className: "column-quantity" }, t('Quantity')),
        (isOption || isPackage) &&
            (quantityTypeValue === 'GRANULAR' ||
                quantityTypeValue === 'ITEM_CONFIGURATION') && (React.createElement("th", { className: "column-quantity" }, t('Quantity'))),
        editable && React.createElement("th", { className: "column-amount" }, t('Price')),
        editable && user.isContactUser() && dealerColumn && (React.createElement("th", { className: "column-amount" },
            React.createElement("div", { className: "deal-item-panel-title" },
                dealerDiscount + '% ' + t('Discount'),
                React.createElement("div", { className: "deal-item-panel-title-tooltip" },
                    React.createElement(Icon, { className: "deal-item-panel-title-tooltip-picto", value: "circle-info" }),
                    React.createElement(Text, { className: "deal-item-panel-title-tooltip-value", value: t('This amount represents your dealer discount.') }))))),
        editable && user.isContactUser() && dealerColumn && (React.createElement("th", { className: "column-amount" },
            React.createElement("div", { className: "deal-item-panel-title" },
                t('Dealer Price'),
                React.createElement("div", { className: "deal-item-panel-title-tooltip" },
                    React.createElement(Icon, { className: "deal-item-panel-title-tooltip-picto", value: "circle-info" }),
                    React.createElement(Text, { className: "deal-item-panel-title-tooltip-value", value: t('Cost Price - Dealer Discount') }))))),
        editable && pricingParameters == 'DISCOUNT' && (React.createElement("th", null,
            React.createElement("div", { className: "deal-item-panel-title" },
                t('Discount') + ' (%)',
                React.createElement("div", { className: "deal-item-panel-title-tooltip" },
                    React.createElement(Icon, { className: "deal-item-panel-title-tooltip-picto", value: "circle-info" }),
                    React.createElement(Text, { className: "deal-item-panel-title-tooltip-value", value: t('The percentage subtracted from the selling price to set the price.') }))))),
        pricingParameters == 'MARKUP' && pricingParametersDisplay == 'line' && (React.createElement("th", null,
            React.createElement("div", { className: "deal-item-panel-title" },
                t('Markup (%)'),
                React.createElement("div", { className: "deal-item-panel-title-tooltip" },
                    React.createElement(Icon, { className: "deal-item-panel-title-tooltip-picto", value: "circle-info" }),
                    React.createElement(Text, { className: "deal-item-panel-title-tooltip-value", value: t('The percentage added to the cost price to set the selling price.') }))))),
        pricingParameters == 'MARKUP' &&
            pricingParametersDisplay == 'item' &&
            !isOption &&
            !isPackage && (React.createElement("th", null,
            React.createElement("div", { className: "deal-item-panel-title" },
                t('Markup (%)'),
                React.createElement("div", { className: "deal-item-panel-title-tooltip" },
                    React.createElement(Icon, { className: "deal-item-panel-title-tooltip-picto", value: "circle-info" }),
                    React.createElement(Text, { className: "deal-item-panel-title-tooltip-value", value: t('The percentage added to the cost price to set the selling price.') }))))),
        pricingParameters == 'MARGIN' && pricingParametersDisplay == 'line' && (React.createElement("th", null,
            React.createElement("div", { className: "deal-item-panel-title" },
                t('Margin') + ' (%)',
                React.createElement("div", { className: "deal-item-panel-title-tooltip" },
                    React.createElement(Icon, { className: "deal-item-panel-title-tooltip-picto", value: "circle-info" }),
                    React.createElement(Text, { className: "deal-item-panel-title-tooltip-value", value: t('The percentage of the selling price that is profit.') }))))),
        pricingParameters == 'MARGIN' &&
            pricingParametersDisplay == 'item' &&
            !isOption &&
            !isPackage && (React.createElement("th", null,
            React.createElement("div", { className: "deal-item-panel-title" },
                t('Margin') + ' (%)',
                React.createElement("div", { className: "deal-item-panel-title-tooltip" },
                    React.createElement(Icon, { className: "deal-item-panel-title-tooltip-picto", value: "circle-info" }),
                    React.createElement(Text, { className: "deal-item-panel-title-tooltip-value", value: t('The percentage of the selling price that is profit.') }))))),
        (pricingDisplay === 'ALL' ||
            pricingDisplay === 'BUNDLED' ||
            pricingDisplay === 'LINE' ||
            editable) && React.createElement("th", { className: "column-amount" }, t('Selling Price')),
        (pricingDisplay === 'ALL' ||
            pricingDisplay === 'BUNDLED' ||
            pricingDisplay === 'LINE' ||
            editable) && React.createElement("th", { className: "column-amount" }, t('Amount')),
        React.createElement("th", null)));
}
